import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import React from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";

// Contexto de autenticação
import { AuthProvider } from "./context/AuthContext";

// Componentes
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";

// Páginas
import AdminDashboard from "./pages/AdminDashboard";
import Agenda from "./pages/Agenda";
import Assinatura from "./pages/Assinatura";
import Clientes from "./pages/Clientes";
import Dashboard from "./pages/Dashboard";
import Impostos from "./pages/Impostos";
import Login from "./pages/Login";
import Obrigacoes from "./pages/Obrigacoes";
import ObrigacoesEnviadas from "./pages/ObrigacoesEnviadas";
import Perfil from "./pages/Perfil";
import Prioridades from "./pages/Prioridades";
import Recorrencias from "./pages/Recorrencias";
import Relatorios from "./pages/Relatorios";
import ResetSenha from "./pages/ResetSenha";
import Setores from "./pages/Setores";
import Tarefas from "./pages/Tarefas";
import Usuarios from "./pages/Usuarios";

// Tema Material-UI
const theme = createTheme({
  palette: {
    primary: {
      main: "#2563eb",
    },
    secondary: {
      main: "#f59e0b",
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/reset-senha" element={<ResetSenha />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Routes>
                      <Route
                        path="/"
                        element={<Navigate to="/agenda" replace />}
                      />
                      <Route path="/dashboard" element={<Dashboard />} />
                      <Route path="/agenda" element={<Agenda />} />
                      <Route path="/clientes" element={<Clientes />} />
                      <Route path="/obrigacoes" element={<Obrigacoes />} />
                      <Route
                        path="/usuarios"
                        element={
                          <ProtectedRoute requirePermission="admin">
                            <Usuarios />
                          </ProtectedRoute>
                        }
                      />
                      <Route path="/impostos" element={<Impostos />} />
                      <Route
                        path="/prioridades"
                        element={
                          <ProtectedRoute requirePermission="admin">
                            <Prioridades />
                          </ProtectedRoute>
                        }
                      />
                      <Route path="/recorrencias" element={<Recorrencias />} />
                      <Route
                        path="/setores"
                        element={
                          <ProtectedRoute requirePermission="admin">
                            <Setores />
                          </ProtectedRoute>
                        }
                      />
                      <Route path="/relatorios" element={<Relatorios />} />
                      <Route
                        path="/relatorios/obrigacoes-enviadas"
                        element={<ObrigacoesEnviadas />}
                      />
                      <Route path="/tarefas" element={<Tarefas />} />
                      <Route path="/assinatura" element={<Assinatura />} />
                      <Route path="/perfil" element={<Perfil />} />
                      <Route
                        path="/admin"
                        element={
                          <ProtectedRoute requireSuperAdmin={true}>
                            <AdminDashboard />
                          </ProtectedRoute>
                        }
                      />
                    </Routes>
                  </Layout>
                </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
